// External Dependencies
import {
  blueGrey900,
  deepOrange50,
  grey200,
  grey600,
  grey700,
  grey900,
  lightBlueA400,
  red300,
  red400,
  red800,
  red900,
  teal200,
  teal300,
  teal500,
} from 'material-ui/styles/colors';

export default {
  addToCalendar: {
    anchor: {
      color: '#00B0FF',
      textDecoration: 'none',
    },
  },

  appBarComponent: {
    buttonPanelItem: {
      color: deepOrange50,
      borderRadius: '0',
      marginRight: '30px',
      marginTop: '20px',
    },
    appBar: {
      background: blueGrey900,
      borderBottomStyle: 'solid',
      borderBottomColor: red400,
      verticalAlign: 'middle',
    },
    logo: {
      height: '70px',
      width: '140px',
      paddingLeft: '20px',
    },
    buttonPanelItemHover: red400,
  },

  badgeList: {
    mainSection: {
      marginTop: '7%',
      marginLeft: '50px',
      display: 'table',
      width: '85%',
    },
    container: {
      width: '300px',
      height: '500px',
      left: '13%',
      position: 'relative',
      margin: '20px',
      display: 'flex',
      float: 'left',
      background: grey200,
      borderRadius: '0',
    },
    badgeImage: {
      padding: '10px',
      width: '280px',
    },
    badgeInfoSection: {
      position: 'relative',
      marginBottom: '0',
      width: '300px',
    },
    badgeTitleText: {
      fontSize: '25pt',
      fontWeight: '400',
      lineHeight: '35pt',
      color: 'white',
      textAlign: 'center',
      padding: '3px',
      background: teal300,
      textShadow: '1px 1px 1px grey',
    },
    badgeSubtitleText: {
      color: red800,
      fontSize: '12pt',
      float: 'left',
      paddingRight: '5px',
      fontWeight: '400',
    },
    badgeCardText: {
      color: grey700,
      fontSize: '12pt',
      padding: '10px',
      marginLeft: '10px',
      wordWrap: 'normal',
      fontWeight: '300',
    },
    infoDiv: {
      background: 'white',
      height: '150px',
    },
    infoInnerDiv: {
      padding: '10px',
      width: '90%',
      display: 'table',
    },
    categoryChip: {
      textAlign: 'center',
      float: 'left',
      background: '#FF5252',
      color: 'white',
      padding: '2px',
      margin: '2px',
      display: 'inline',
    },
    labelColor: '#FFEBEE',
  },
  codersCard: {
    Card: {
      width: '400px',
      height: '450px',
      left: '15%',
      position: 'relative',
      margin: '40px',
      display: 'flex',
      float: 'left',
      textAlign: 'center',
      borderRadius: '0',
    },
    CoderCardImage: {
      height: '150px',
      width: 'auto',
      padding: '50px',
      margin: '0px',
      background: 'white',
      display: 'flex',
    },
    CoderTitleText: {
      color: 'white',
      fontSize: '30pt',
      lineHeight: '35pt',
      padding: '70px 20px 20px 20px',
      textShadow: '1px 1px 1px grey',
    },
    CoderLevelText: {
      fontSize: '15pt',
      fontWeight: '400',
      color: red900,
    },
    mainSection: {
      height: '100%',
      position: 'relative',
      width: '400px',
      background: '#FF8A80',
    },
    badgesListDiv: {
      margin: '15px',
      overflow: 'overlay',
      maxHeight: '160px',
      textAlign: 'center',
    },
    metricsDiv: {
      position: 'absolute',
      bottom: '0',
    },
    badgeSize: '72px',
  },
  coderCardMetrics: {
    mainSection: {
      borderCollapse: 'collaspe',
      paddingTop: '10px',
    },
    CoderMetricRowOne: {
      textAlign: 'center',
      padding: '0',
      margin: '0',
      color: teal500,
      fontSize: '25pt',
      fontWeight: '400',
    },
    CoderMetricRowTwo: {
      textAlign: 'center',
      padding: '0',
      margin: '0',
      fontWeight: '300',
    },
  },
  coderDetailsPage: {
    textStyle: {
      fontSize: '15pt',
      fontWeight: '400',
      color: 'white',
    },
    dateText: {
      fontWeight: '300',
      lineHeight: '35pt',
      color: '#616161',
      fontSize: '13pt',
    },

    ProfileCoderDetails: {
      backgroundColor: red400,
      width: '80%',
      position: 'relative',
      left: '7%',
      padding: '20px',
    },

    ProfileNameText: {
      color: 'white',
      fontSize: '25pt',
      fontWeight: '300',
      lineHeight: '35pt',
    },
    ProfileAvatar: {
      height: 230,
      width: 230,
      margin: 20,
      textAlign: 'center',
      backgroundColor: red300,
      display: 'inline-block',
      padding: '10px',
    },
    activitySection: {
      backgroundColor: 'white',
      width: '80%',
      position: 'relative',
      left: '7%',
      padding: '20px',
    },

    mainSection: {
      textAlign: 'center',
      padding: '20px',
      width: '100%',
      height: 'auto',
    },
    stepperSection: {
      marginTop: '20px',
    },
    stepperAvatar: {
      padding: '2px',
    },
    avatarBGColor: '#4DB6AC',
    badgesListDiv: {
      marginTop: '20px',
      marginBottom: '30px',
      display: 'flex',
      textAlign: 'center',
    },
    badgeSize: '200px',
    stepperText: {
      fontSize: '15pt',
    },
    attendanceListDiv: {
      position: 'relative',
      left: '2%',
      textAlign: 'left',
    },
  },
  coderList: {
    searchSection: {
      position: 'fixed',
      width: '100%',
      padding: '5px',
    },
    searchIconSize: '12px',
    searchTextBox: {
      float: 'right',
      color: 'white',
      paddingRight: '4px',
    },
    hintStyle: {
      color: 'grey',
      fontWeight: '100',
    },
    inputStyle: {
      color: 'white',
    },
    coderListSection: {
      marginTop: '10px',
      marginLeft: '50px',
      display: 'table',
      width: '85%',
    },
  },
  codersPage: {
    mainSection: {
      margin: '85px 0px 0px 0px',
      height: '100%',
    },
  },
  homePage: {
    container: {
      position: 'relative',
    },

    footer: {
      textAlign: 'center',
      fontSize: '8pt',
      color: lightBlueA400,
      padding: 20,
      background: grey900,
      bottom: 0,
    },
    footerInnerDiv: {
      width: '100%',
      textAlign: 'center',
    },
    linkStyle: {
      color: '#00B0FF',
      textDecoration: 'none',
    },
  },
  homePageComponent: {
    homePageHelloDiv: {
      background: 'white',
      textAlign: 'center',
      width: '100%',
      paddingTop: 20,
      paddingBottom: 20,
    },
    homePagePicDiv: {
      background: teal200,
      display: 'flex',
      padding: '4%',
      color: 'white',
    },
    homePageEventDiv: {
      background: red400,
      display: 'flex',
      padding: '4%',
      color: 'white',
    },
    h4text: {
      width: '100%',
      // fontWeight: '300',
      color: grey600,
    },
    buttonPanelItem: {
      color: deepOrange50,
      borderRadius: '0',
      marginRight: 30,
      marginTop: 20,
    },
    buttonPanelItemHover: red400,
    hoverColor: red800,
    breadcrumbBtnColor: teal300,
    breadcrumbHoverColor: teal500,
    registerNowBtn: {
      color: deepOrange50,
      borderRadius: '0',
      marginRight: '30px',
      marginTop: '20px',
      width: '30%',
      marginBottom: '20px',
      display: 'none',
    },
    iconStyle: {
      width: '30px',
      height: '30px',
    },
    pictureContainer: {
      width: 'auto',
      height: 'auto',
      padding: '10px',
      left: '5%',
      position: 'relative',
      margin: '10px',
    },
    heartPicture: {
      width: '20px',
      height: '20px',
      margin: '5px',
      position: 'relative',
      top: '10px',
    },
    homePagePicture: {
      width: '400px',
      height: 'auto',
    },
  },

  header: {
    zIndex: 1,
    width: '100%',
    position: 'fixed',
    top: '0px',
  },
  mainSection: {
    margin: '85px 0px 0px 0px',
    height: '100%',
  },
  hoverColor: red800,
  breadcrumbBtnColor: teal300,
  breadcrumbHoverColor: teal500,
  container: {
    width: '300px',
    height: '500px',
    left: '13%',
    position: 'relative',
    margin: '20px',
    display: 'flex',
    float: 'left',
    background: grey200,
    borderRadius: '0',
  },
  badgeImageContainer: {
    width: '20%',
    margin: '10px',
  },
  pictureContainer: {
    width: 'auto',
    height: 'auto',
    padding: '10px',
    left: '5%',
    position: 'relative',
    margin: '10px',
  },
  heartPicture: {
    width: '20px',
    height: '20px',
    margin: '5px',
    position: 'relative',
    top: '10px',
  },
  homePagePicture: {
    width: '400px',
    height: 'auto',
  },
  // card styles
  card: {
    width: '800px',
    height: '70px',
    margin: '0px auto 10px auto',
  },
  cardContents: {
    float: 'right',
    display: 'flex',
  },
  cardChip: {
    paddingTop: '2px',
    marginRight: '10px',
  },
  chipCount: {
    padding: '0px',
    marginLeft: '30px',
    marginRight: '-5px',
    marginBottom: '17px',
  },
  // badge grid styles
  badgesGridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  badgesGrid: {
    marginTop: '10px',
    marginLeft: '3px',
    width: '814px',
  },
  badgeTile: {
    marginLeft: '3px',
    height: '190px',
    width: 'auto',
    paddingBottom: '-40px',
  },
  badgeImage: {
    padding: '10px',
    width: '280px',
  },
  badgeTitleCard: {
    marginLeft: '3px',
    marginTop: '5px',
    padding: '10px',
    width: '190px',
    background: grey600,
  },
  badgeInfoSection: {
    position: 'relative',
    marginBottom: '0',
    width: '300px',
  },
  badgeTitleText: {
    fontSize: '25pt',
    fontWeight: '400',
    lineHeight: '35pt',
    color: 'white',
    textAlign: 'center',
    padding: '3px',
    background: teal300,
    textShadow: '1px 1px 1px grey',
  },
  badgeSubtitleText: {
    color: red800,
    fontSize: '12pt',
    float: 'left',
    paddingRight: '5px',
    fontWeight: '400',
  },
  badgeCardText: {
    color: grey700,
    fontSize: '12pt',
    padding: '10px',
    marginLeft: '10px',
    wordWrap: 'normal',
    fontWeight: '300',
  },
  homePageHelloDiv: {
    background: 'white',
    textAlign: 'center',
    width: '100%',
    padding: '32px 0px',
  },
  homePagePicDiv: {
    background: teal200,
    display: 'flex',
    padding: '4%',
    color: 'white',
  },
  homePageEventDiv: {
    background: red400,
    display: 'flex',
    padding: '4%',
    color: 'white',
  },
  helloWorldText: {
    color: teal500,
    fontSize: '40pt',
    fontWeight: '100',
    lineHeight: '35pt',
    padding: '20px',
    textAlign: 'center',
  },
  picDivText: {
    color: 'white',
    width: '40%',
    height: '100%',
    textAlign: 'center',
    fontWeight: '300',
    marginLeft: '20%',
    marginTop: '5%',
    verticalAlign: 'middle',
  },

  h4text: {
    fontSize: '12pt',
    width: '100%',
    fontWeight: '300',
    textAlign: 'center',
    color: grey600,
  },

  registerNowBtn: {
    color: deepOrange50,
    borderRadius: '0',
    marginRight: '30px',
    marginTop: '20px',
    width: '30%',
    marginBottom: '20px',
    display: 'none',
  },
  iconStyle: {
    width: '30px',
    height: '30px',
  },
  coderCard: {
    width: '400px',
    height: '450px',
    left: '15%',
    position: 'relative',
    margin: '40px',
    display: 'flex',
    float: 'left',
    textAlign: 'center',
    borderRadius: '0',
  },
  CoderCardImage: {
    height: '150px',
    width: 'auto',
    padding: '50px',
    margin: '0px',
    background: 'white',
    display: 'flex',
  },
  CoderTitleText: {
    color: 'white',
    fontSize: '30pt',
    lineHeight: '35pt',
    padding: '70px 20px 20px 20px',
    textShadow: '1px 1px 1px grey',
  },
  CoderLevelText: {
    fontSize: '15pt',
    fontWeight: '400',
    color: red900,
  },
  viewProfileBtn: {
    margin: '0px',
    width: '100%',
    color: 'white',
    borderRadius: '0',
    display: 'block',
    position: 'absolute',
    bottom: '0',
  },
  viewProfileBtnBg: red400,

  CoderMetricRow: {
    textAlign: 'center',
    padding: '0',
    margin: '0',
    color: teal500,
    fontSize: '25pt',
    fontWeight: '400',
  },
  ProfileCoderDetails: {
    backgroundColor: red400,
    width: '80%',
    position: 'relative',
    left: '7%',
    padding: '20px',
  },
  ProfileNameText: {
    color: 'white',
    fontSize: '25pt',
    fontWeight: '300',
    lineHeight: '35pt',
  },
  ProfileAvatar: {
    height: 230,
    width: 230,
    margin: 20,
    textAlign: 'center',
    backgroundColor: red300,
    display: 'inline-block',
    padding: '10px',
  },
  badgeInfoText: {
    fontSize: '12pt',
    color: grey700,
    fontWeight: '300',
    lineHeight: '17pt',
  },
};



/** WEBPACK FOOTER **
 ** ./src/styles/Styles.js
 **/